var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMelon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD553"
    },
    cx: 256.002,
    cy: 256.002,
    r: 247.949
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.7,
      fill: "#FFB446",
      enableBackground: "new"
    },
    cx: 256.002,
    cy: 256.002,
    r: 193.188
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBA55"
    },
    d: "M8.053,256c0,136.938,111.009,247.947,247.947,247.947S503.947,392.938,503.947,256H8.053z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 112.775,
    cy: 388.245,
    r: 14.581
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 248.926,
    cy: 455.16,
    r: 14.581
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 442.748,
    cy: 336.071,
    r: 14.581
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 374.178,
    cy: 379.977,
    r: 14.581
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 224.745,
    cy: 308.186,
    r: 14.581
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 187.519,
    cy: 409.14,
    r: 14.581
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 340.098,
    cy: 438.302,
    r: 14.581
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 278.089,
    cy: 379.977,
    r: 14.581
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 157.819,
    cy: 336.071,
    r: 14.581
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 345.016,
    cy: 308.186,
    r: 14.581
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CF9945"
    },
    cx: 67.775,
    cy: 308.186,
    r: 14.581
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3F4963"
    },
    cx: 181.173,
    cy: 180.217,
    r: 15.213
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6376"
    },
    d: "M197.443,228.556h-32.548c-4.449,0-8.053-3.605-8.053-8.053c0-4.449,3.605-8.053,8.053-8.053h32.548 c4.449,0,8.053,3.605,8.053,8.053C205.496,224.952,201.891,228.556,197.443,228.556z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3F4963"
    },
    cx: 330.831,
    cy: 180.217,
    r: 15.213
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6376"
    },
    d: "M347.105,228.556h-32.548c-4.449,0-8.053-3.605-8.053-8.053c0-4.449,3.605-8.053,8.053-8.053h32.548 c4.449,0,8.053,3.605,8.053,8.053C355.158,224.952,351.552,228.556,347.105,228.556z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F4963"
    },
    d: "M240.877,215.615c-12.78,0-23.177-10.397-23.177-23.176c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053c0,3.899,3.172,7.07,7.071,7.07c3.899,0,7.07-3.171,7.07-7.07c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053C264.053,205.218,253.656,215.615,240.877,215.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F4963"
    },
    d: "M271.124,215.615c-12.78,0-23.177-10.397-23.177-23.176c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053c0,3.899,3.172,7.07,7.071,7.07s7.07-3.171,7.07-7.07c0-4.449,3.605-8.053,8.053-8.053 s8.053,3.605,8.053,8.053C294.299,205.218,283.902,215.615,271.124,215.615z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD151"
    },
    d: "M244.189,157.574c-4.449,0-8.053-3.605-8.053-8.053v-13.959c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053v13.959C252.242,153.97,248.637,157.574,244.189,157.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD151"
    },
    d: "M278.549,134.667c-4.449,0-8.053-3.605-8.053-8.053v-13.959c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053v13.959C286.602,131.062,282.997,134.667,278.549,134.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD151"
    },
    d: "M164.895,150.595c-4.449,0-8.053-3.605-8.053-8.053v-13.959c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053v13.959C172.948,146.99,169.343,150.595,164.895,150.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD151"
    },
    d: "M130.583,183.44c-4.449,0-8.053-3.605-8.053-8.053v-13.959c0-4.449,3.605-8.053,8.053-8.053 c4.447,0,8.053,3.605,8.053,8.053v13.959C138.637,179.834,135.032,183.44,130.583,183.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD151"
    },
    d: "M112.781,227.743c-4.449,0-8.053-3.605-8.053-8.053v-13.959c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053v13.959C120.834,224.138,117.229,227.743,112.781,227.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD151"
    },
    d: "M206.25,127.688c-4.449,0-8.053-3.605-8.053-8.053v-13.959c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053v13.959C214.303,124.083,210.699,127.688,206.25,127.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD151"
    },
    d: "M310.045,127.688c-4.449,0-8.053-3.605-8.053-8.053v-13.959c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053v13.959C318.098,124.083,314.493,127.688,310.045,127.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD151"
    },
    d: "M345.011,150.595c-4.449,0-8.053-3.605-8.053-8.053v-13.959c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053v13.959C353.064,146.99,349.46,150.595,345.011,150.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD151"
    },
    d: "M374.175,188.271c-4.449,0-8.053-3.605-8.053-8.053V166.26c0-4.449,3.605-8.053,8.053-8.053 c4.449,0,8.053,3.605,8.053,8.053v13.959C382.228,184.666,378.623,188.271,374.175,188.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD151"
    },
    d: "M399.882,227.743c-4.449,0-8.053-3.605-8.053-8.053v-13.959c0-4.449,3.605-8.053,8.053-8.053 s8.053,3.605,8.053,8.053v13.959C407.935,224.138,404.33,227.743,399.882,227.743z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.17,165.004c-8.401,0-15.213,6.812-15.213,15.213c0,8.403,6.812,15.215,15.213,15.215 c8.402,0,15.213-6.812,15.213-15.215C196.382,171.816,189.572,165.004,181.17,165.004z M286.246,184.387 c-4.449,0-8.053,3.605-8.053,8.053c0,3.899-3.171,7.07-7.07,7.07c-3.899,0-7.071-3.171-7.071-7.07c0-4.449-3.605-8.053-8.053-8.053 c-4.449,0-8.053,3.605-8.053,8.053c0,3.899-3.171,7.07-7.07,7.07s-7.071-3.171-7.071-7.07c0-4.449-3.605-8.053-8.053-8.053 c-4.449,0-8.053,3.605-8.053,8.053c0,12.78,10.397,23.176,23.177,23.176c5.78,0,11.06-2.141,15.123-5.652 c4.064,3.511,9.344,5.652,15.124,5.652c12.779,0,23.176-10.396,23.176-23.176C294.299,187.991,290.694,184.387,286.246,184.387z  M437.019,74.982C388.669,26.63,324.38,0,256,0S123.331,26.63,74.981,74.982C26.629,123.331,0,187.62,0,256 s26.629,132.669,74.981,181.02C123.331,485.372,187.62,512,256,512s132.669-26.628,181.019-74.98 C485.371,388.669,512,324.38,512,256S485.371,123.331,437.019,74.982z M86.37,86.37C131.679,41.06,191.921,16.106,256,16.106 S380.321,41.06,425.63,86.37c43.407,43.405,68.114,100.519,70.115,161.577h-38.678C452.824,140.702,364.268,54.759,256,54.759 S59.176,140.702,54.933,247.947H16.254C18.256,186.888,42.963,129.774,86.37,86.37z M440.95,247.947H71.05 C75.281,149.587,156.614,70.865,256,70.865S436.719,149.587,440.95,247.947z M425.63,425.63 c-45.309,45.311-105.552,70.264-169.63,70.264S131.679,470.942,86.37,425.63c-43.407-43.405-68.114-100.519-70.116-161.577h479.492 C493.744,325.112,469.037,382.226,425.63,425.63z M330.83,165.004c-8.403,0-15.213,6.812-15.213,15.213 c0,8.403,6.81,15.215,15.213,15.215c8.401,0,15.213-6.812,15.213-15.215C346.043,171.816,339.232,165.004,330.83,165.004z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelon);
export default __webpack_public_path__ + "static/media/melon.f06828bb3938a3f8d0b0cbef79474670.svg";
export { ForwardRef as ReactComponent };